

<div class="d-flex">
  <!-- sidebar -->
  <app-side-bar></app-side-bar>
  <!-- fin sidebar -->
  <app-gif-page class="container"></app-gif-page>
</div>